import { NavCount } from "components";
import { IncompleteTyresTable } from "modules/IncompleteTyresDashboard/components";
import { useIncompleteTyresQuery } from "modules/IncompleteTyresDashboard/hooks";

export const IncompleteTyresDashboard = () => {
  const { nbItems } = useIncompleteTyresQuery();

  return (
    <>
      <NavCount total={nbItems} />
      <IncompleteTyresTable />
    </>
  );
};
